import React from 'react';
import styles from './index.scss';
import logoSrc from './imgs/p2p.jpg';
import PropTypes from 'prop-types';

const Header = (props) => {
const {logout, user} = props;
  {window.onbeforeunload = function () {   
      logout(user);
      localStorage.clear();
  }}
  return (<div className={ styles.headerBar }>
    <img src={ logoSrc } />  
  </div>)
};

Header.propTypes = {
  user: PropTypes.shape({}),
  logout: PropTypes.func
}

export default Header;



// WEBPACK FOOTER //
// ./src/header/header.presentation.jsx